<template>
  <operaciones-rappel-mensual-grid :idRappel="props.IdRappel" ></operaciones-rappel-mensual-grid>
</template>

<script setup lang="ts">
import { useModalBuilder } from '@/.shared/helpers/modal-building-helper';
import { getCurrentInstance, onMounted } from 'vue';
import OperacionesRappelMensualGrid from '@/components/facturas/OperacionesRappelMensualGrid.vue';
import {messageBoxResult} from "@components/dialogs/message-box";

const props = defineProps(["IdRappel"]);

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)

  configureButtons(modal);
});

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  modal.standardButtons.addOk().update(w => w.onClick = () => modal.close(messageBoxResult.ok));
  
}

</script>

<style lang="scss" scoped></style>